import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { Grid, TextField, SelectChangeEvent } from '@mui/material';
import AnalyzerSelectLocal from 'features/analyzers/AnalyzerSelectLocal';

import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';
import { Filter } from './types';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';

interface Props {
  filter: Filter;
  handleFilterChanged: (newFilter: Filter) => void;
}

const TimeWarningLogFilters = ({ filter, handleFilterChanged }: Props) => {
  const { data: analyzers } = useAnalyzers({});
  const { dateFormatWithZeros, timeFormat, ampm } = useUserDateTime();
  const { fromDate, toDate, analyzerId } = filter;

  const handleFromDateChanged = (date: any) => {
    handleFilterChanged({
      ...filter,
      fromDate: date,
    });
  };

  const handleToDateChanged = (date: any) => {
    handleFilterChanged({
      ...filter,
      toDate: date,
    });
  };

  const handleAnalyzerChanged = (event: SelectChangeEvent) => {
    handleFilterChanged({
      ...filter,
      analyzerId: Number(event.target.value),
    });
  };

  return (
    <>
      <Grid container xs={12} item spacing={3}>
        <Grid item style={{ width: '15rem' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label='From'
              maxDate={toDate}
              inputFormat={`${dateFormatWithZeros} ${timeFormat}`}
              value={fromDate}
              onChange={handleFromDateChanged}
              renderInput={(params) => <TextField {...params} />}
              ampm={ampm}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item style={{ width: '15rem' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label='To'
              minDate={fromDate}
              inputFormat={`${dateFormatWithZeros} ${timeFormat}`}
              value={toDate}
              onChange={handleToDateChanged}
              renderInput={(params) => <TextField {...params} />}
              ampm={ampm}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={1} style={{ minWidth: '10rem' }}>
          <AnalyzerSelectLocal
            analyzers={analyzers}
            selectedAnalyzerId={analyzerId}
            handleAnalyzerChanged={handleAnalyzerChanged}
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TimeWarningLogFilters;
